
import { Options, Vue } from 'vue-class-component'
import { formatNoticeHtml, formatNoticeHtmlInline } from '@/utils/migration'

@Options({})
export default class MigrationBanner extends Vue {
  visible = false
  dialogVisible = false
  noticeText = ''
  cutoverStart = 0
  cutoverEnd = 0
  countdown = ''
  private timer = 0
  private boundInit!: () => void
  private alertedThisLoad = false
  private static readonly MIN_NOTICE_TIMES = 5

  get noticeHtmlInline(): string {
    return formatNoticeHtmlInline(
      this.noticeText,
      '学校教学平台即将进行数据迁移，迁移期间平台将暂停使用，请提前做好安排。'
    )
  }

  get noticeHtml(): string {
    return formatNoticeHtml(
      this.noticeText,
      '学校平台即将进行数据迁移，迁移期间将暂停使用。'
    )
  }

  created(): void {
    this.boundInit = this.init.bind(this)
    window.addEventListener('migrationNotice', this.boundInit)
    this.init()
  }

  init(): void {
    const migration = (window as any).schoolConfig && (window as any).schoolConfig.migration
    if (!migration || Number(migration.phase) !== 1) {
      return
    }
    this.noticeText = String(migration.notice_text || '')
    this.cutoverStart = Number(migration.cutover_start || 0)
    this.cutoverEnd = Number(migration.cutover_end || 0)
    if (this.cutoverStart > 0 && !this.timer) {
      this.updateCountdown()
      this.timer = window.setInterval(this.updateCountdown, 1000)
    }
    this.showNoticeDialog()
    if (sessionStorage.getItem('migrationBannerDismissed') === '1') {
      return
    }
    if (!this.visible) {
      this.visible = true
    }
  }

  showNoticeDialog(): void {
    if (this.alertedThisLoad) {
      return
    }
    const key = 'migrationNoticeCount:' + this.cutoverStart
    const shown = Number(localStorage.getItem(key) || '0')
    if (shown >= MigrationBanner.MIN_NOTICE_TIMES) {
      return
    }
    this.alertedThisLoad = true
    localStorage.setItem(key, String(shown + 1))
    this.dialogVisible = true
  }

  closeNoticeDialog(): void {
    this.dialogVisible = false
  }

  unmounted(): void {
    if (this.timer) {
      clearInterval(this.timer)
    }
    window.removeEventListener('migrationNotice', this.boundInit)
  }

  updateCountdown(): void {
    const diff = this.cutoverStart - Math.floor(Date.now() / 1000)
    if (diff <= 0) {
      this.countdown = ''
      if (this.timer) clearInterval(this.timer)
      return
    }
    const d = Math.floor(diff / 86400)
    const h = Math.floor((diff % 86400) / 3600)
    const m = Math.floor((diff % 3600) / 60)
    const s = diff % 60
    this.countdown = d > 0 ? `${d}天${h}小时${m}分` : `${h}小时${m}分${s}秒`
  }

  formatTime(ts: number): string {
    if (!ts) return '--'
    const d = new Date(ts * 1000)
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n)
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
  }

  dismiss(): void {
    this.visible = false
    sessionStorage.setItem('migrationBannerDismissed', '1')
  }
}
